import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import { convertTokensToDollars } from 'utils/helpers';
import ApiService from 'services/ApiService/ApiService';

import {
  PERFORMER_DETAILS_URL,
  PERFORMER_HOURS_URL,
  PERFORMER_PRIVATE_SHOW_REVENUE_URL,
  PERFORMER_REVENUE_INSIGHTS,
} from './Api';


const PERFORMER_DETAILS = 'cam4/studio/PERFORMER_DETAILS';
const PERFORMER_HOURS_DATA = 'cam4/studio/PERFORMER_HOURS_DATA';
const PERFORMER_PRIVATE_SHOW_DATA = 'cam4/studio/PERFORMER_PRIVATE_SHOW_DATA';
const PERFORMER_REVENUE = 'cam4/studio/PERFORMER_REVENUE';

const initialState = Immutable.fromJS({
  performerDetails: [],
  performerRevenue: [],
  performerHoursData: {},
  performerPrivateShowData: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PERFORMER_DETAILS:
      return state.set('performerDetails', Immutable.fromJS(action.performerDetails));

    case PERFORMER_REVENUE:
      return state.set('performerRevenue', Immutable.fromJS(action.performerRevenue));

    case PERFORMER_HOURS_DATA:
      return state.set('performerHoursData', Immutable.fromJS(action.performerHoursData));

    case PERFORMER_PRIVATE_SHOW_DATA:
      return state.set('performerPrivateShowData', Immutable.fromJS(action.performerPrivateShowData));

    default:
      return state;
  }
}

export const NAME = 'performerDetails';

const performerDetails = (state) => state[NAME].get('performerDetails');
const performerRevenue = (state) => state[NAME].get('performerRevenue');
const performerHoursData = (state) => state[NAME].get('performerHoursData');
const performerPrivateShowData = (state) => state[NAME].get('performerPrivateShowData');

export const selector = createStructuredSelector({
  performerDetails,
  performerRevenue,
  performerHoursData,
  performerPrivateShowData,
});

function displayPerformerPrivateShowData(data) {
  return {
    type: PERFORMER_PRIVATE_SHOW_DATA,
    performerPrivateShowData: data,
  };
}

function displayPerformerHours(data) {
  return {
    type: PERFORMER_HOURS_DATA,
    performerHoursData: data,
  };
}

function displayPerformerDetails(res) {
  return {
    type: PERFORMER_DETAILS,
    performerDetails: res.data,
  };
}

function displayPerformerRevenue(performerRevenue) {
  return {
    type: PERFORMER_REVENUE,
    performerRevenue,
  };
}

function getPerformerDetails(performerName) {
  const url = ApiService.substitute(PERFORMER_DETAILS_URL, { performerName });

  return (dispatch) => ApiService
    .get(url)
    .then((res) => {
      dispatch(displayPerformerDetails(res));
    });
}

/**
 * parsing response and converting tokens to dollars
 * @param res
 * @returns {RequestInterface}
 */
function parsePerformerRevenueResults(res) {
  const data = [];
  let counter = 0;

  res.data?.forEach?.((n) => {
    data[counter] = n;
    data[counter].amount = convertTokensToDollars(n.amount);
    data[counter].id = counter;
    data[counter].key = counter;
    data[counter].amountPerHour = convertTokensToDollars(
      data[counter].hours ? (data[counter].amount / data[counter].hours).toFixed(2) : 0
    );
    counter += 1;
  });

  return (dispatch) => {
    dispatch(displayPerformerRevenue(data));
  };
}

function getPerformerRevenue(performerName, date) {
  const [startDate, endDate] = date;
  const url = ApiService.substitute(
    PERFORMER_REVENUE_INSIGHTS,
    { performerName, startDate, endDate }
  );

  return (dispatch) => ApiService
    .get(url)
    .then((res) => {
      dispatch(parsePerformerRevenueResults(res));
    });
}

function getPerformerHours(username, date) {
  const [startTime, endTime] = date;
  const url = ApiService.substitute(
    PERFORMER_HOURS_URL,
    { username, startTime, endTime }
  );

  return (dispatch) => ApiService
    .get(encodeURI(url))
    .then((res) => {
      dispatch(displayPerformerHours(res.data));
    });
}

function getPerformerPrivateShowData(username, date) {
  const [from, to] = date;
  const url = ApiService.substitute(
    PERFORMER_PRIVATE_SHOW_REVENUE_URL,
    { username, from, to }
  );

  return (dispatch) => ApiService
    .get(url)
    .then((res) => {
      dispatch(displayPerformerPrivateShowData(res.data));
    });
}

export const actionCreators = {
  getPerformerDetails,
  getPerformerRevenue,
  getPerformerHours,
  getPerformerPrivateShowData,
};
